var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 no-gap"},[_c('Slide'),(_vm.infoOpen)?_c('InfoSchool',{key:_vm.infoOpen}):_vm._e(),_c('cardUser')],1)}
var staticRenderFns = []

export { render, staticRenderFns }